import React from "react";
import "./index.css";

export const PER_PAGE_OPTIONS = [25, 50, 100];

/** Page numbers to show: 1 … 4 5 [6] 7 8 … 20 */
const pageList = (page, pages) => {
  const out = [];
  const add = (n) => out.push(n);
  const from = Math.max(2, page - 2);
  const to = Math.min(pages - 1, page + 2);
  add(1);
  if (from > 2) add("…a");
  for (let n = from; n <= to; n++) add(n);
  if (to < pages - 1) add("…b");
  if (pages > 1) add(pages);
  return out;
};

/**
 * Pager for server-side paginated lists.
 * Props: page (1-based), perPage, total, onPage(n), onPerPage(n), loading
 */
const Pagination = ({ page, perPage, total, onPage, onPerPage, loading }) => {
  const pages = Math.max(1, Math.ceil((total || 0) / perPage));
  const first = total ? (page - 1) * perPage + 1 : 0;
  const last = Math.min(total || 0, page * perPage);
  const go = (n) => {
    if (n < 1 || n > pages || n === page || loading) return;
    onPage(n);
  };

  return (
    <div className="pgn" role="navigation" aria-label="Pages">
      <span className="pgn-info">
        {total ? `Showing ${first.toLocaleString("en-IN")}–${last.toLocaleString("en-IN")} of ${Number(total).toLocaleString("en-IN")}` : "No results"}
      </span>
      <div className="pgn-pages">
        <button type="button" onClick={() => go(page - 1)} disabled={page <= 1 || loading} aria-label="Previous page">‹</button>
        {pageList(page, pages).map((n) =>
          typeof n === "string" ? (
            <span key={n} className="pgn-gap">…</span>
          ) : (
            <button key={n} type="button" className={n === page ? "is-on" : ""} aria-current={n === page ? "page" : undefined}
              onClick={() => go(n)} disabled={loading && n !== page}>
              {n}
            </button>
          )
        )}
        <button type="button" onClick={() => go(page + 1)} disabled={page >= pages || loading} aria-label="Next page">›</button>
      </div>
      {onPerPage && (
        <label className="pgn-per">
          <span>Rows</span>
          <select value={perPage} onChange={(e) => onPerPage(Number(e.target.value))}>
            {PER_PAGE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
      )}
    </div>
  );
};

export default Pagination;
